import { injectable } from 'inversify';
import { INotificationsCountService } from './notifications-count.interface';
import { Observable, of } from 'rxjs';

@injectable()
export class NotificationsCountMock implements INotificationsCountService {
    unreadCountObservable(): Observable<number> {
        return of(5);
    }
}
